import React from "react";

import Modal from "antd/es/modal/Modal";

import ModalHeader from "./ModalHeader";

import "./SpecManagerModal.css";

const SpecManagerModal = ({
  open,
  title,
  onClose,
  children,
  showBackButton = false,
  onBack,
  stepIndicator = null,
}) => (
  <Modal
    open={open}
    maskClosable={false}
    closable={false}
    centered
    footer={null}
    destroyOnClose
    width={1340}
    wrapClassName="ProdSpecManagerModalWrapper"
    className="ProdSpecManagerModal"
  >
    <div className="ProdSpecManagerModal__Container">
      <ModalHeader
        title={title}
        onClose={onClose}
        showBackButton={showBackButton}
        onBack={onBack}
        stepIndicator={stepIndicator}
      />
      <div className="ProdSpecManagerModal__Body">
        {children}
      </div>
    </div>
  </Modal>
);

export default SpecManagerModal;
